@if (rendering && viewModel$ | async; as vm) {
  <div class="container p-0 m-0">
    @if (vm.showLoader) {
      <wl-loading-screen
        title="Mogelijkheden berekenen voor"
        [subtitle]="
          vm.address?.street +
          ' ' +
          vm.address?.housenumber +
          ' ' +
          vm.address?.postalcode
        "
        [items]="[
          { icon: 'solar-panel', text: 'Maximaal aantal zonnepanelen' },
          {
            icon: 'bolt-lightning',
            text: 'Aantal zonnepanelen nodig voor gebruik',
          },
          { icon: 'coins', text: 'Besparing berekenen' },
        ]"
        [duration]="loaderDuration"
        (finished)="hideLoader()"
      />
    }

    <div class="row">
      <div class="col-12">
        <p class="h1 result-overview-title" *scText="fields?.Title"></p>
        <p class="result-overview-subtitle" *scText="fields?.SubTitle"></p>
      </div>
    </div>

    <div class="grid">
      <div class="grid-address">
        <p wlCSMask>
          {{ vm.address?.street }} {{ vm.address?.housenumber }},
          {{ vm.address?.postalcode }} {{ vm.address?.city }}
        </p>
      </div>
      @if (vm.building) {
        <div class="grid-map">
          <div class="grid-map-border">
            <wl-solar-panels-result-overview-map
              [rendering]="rendering"
              [mapUrl]="vm.building.map"
            ></wl-solar-panels-result-overview-map>
          </div>
        </div>
      }
      @if (fields?.ContactField?.value) {
        <div class="grid-contact">
          <wl-rich-text-wrapper [field]="fields?.ContactField">
            <div class="mt-0"></div>
          </wl-rich-text-wrapper>
        </div>
      }

      @if (vm.product) {
        <div class="grid-summary">
          <p
            class="h4 h3-md m-0"
            *scText="rendering.fields?.DescriptionTitle"
          ></p>
          @if (rendering.fields?.DescriptionText) {
            <p>
              {{
                rendering.fields.DescriptionText.value ?? ''
                  | interpolate
                    : {
                        variables: {
                          maxPanels: vm.product.maxPanelAmount,
                          recommendedPanels: vm.product.recommendation.amount,
                        },
                      }
              }}
            </p>
          }
          <sc-placeholder
            name="solar-panels-result-overview-summary"
            [rendering]="rendering"
          >
            <fa-icon
              *scPlaceholderLoading
              class="text-brand"
              size="3x"
              icon="spinner-third"
              animation="spin"
            ></fa-icon>
          </sc-placeholder>

          @if (accordion) {
            <wl-accordion
              [accordions]="accordion"
              [rendering]="rendering"
              [enableTransparancy]="false"
            ></wl-accordion>
          }
        </div>
      }

      <div class="grid-proposition">
        @if (rendering.fields?.PropositionBoxEnabled?.value === true) {
          <wl-solar-panels-proposition-box
            class="mb-2"
            [rendering]="rendering"
          ></wl-solar-panels-proposition-box>
        }
      </div>

      <div class="grid-submit">
        @if (fields?.InvertButtonPriority?.value) {
          @if (secondaryButtonLinkValue && secondaryButtonLinkValue.href) {
            <a
              class="w-100 mt-4 btn btn-sales-primary"
              *wlGenericLink="secondaryButtonLinkValue"
              wlTrackLink
              [trackLinkInfo]="{
                eventType: 'button-click',
                rendering: rendering,
                field: secondaryButtonLinkValue,
                linkurl: secondaryButtonLinkValue.href,
              }"
            ></a>
          }
          <button
            (click)="onClickSubmitButton(vm.product)"
            class="btn btn-link w-100 mt-2"
            *scText="fields?.NextStepButtonText"
            wlAutomationId="resultOverview.submit"
          ></button>
        } @else {
          <button
            (click)="onClickSubmitButton(vm.product)"
            class="btn btn-sales-primary w-100"
            *scText="fields?.NextStepButtonText"
            wlAutomationId="resultOverview.submit"
          ></button>
          @if (secondaryButtonLinkValue && secondaryButtonLinkValue.href) {
            <a
              class="w-100 mt-2 btn btn-link"
              *wlGenericLink="secondaryButtonLinkValue"
              wlTrackLink
              [trackLinkInfo]="{
                eventType: 'button-click',
                rendering: rendering,
                field: secondaryButtonLinkValue,
                linkurl: secondaryButtonLinkValue.href,
              }"
            ></a>
          }
        }
      </div>
      <div class="grid-usps">
        <wl-rich-text-wrapper [field]="fields?.Usps">
          <div class="mt-2"></div>
        </wl-rich-text-wrapper>
      </div>
    </div>
  </div>
}
